<div class="modal active">
  <div class="modal__container" style="width: 15%;">
    <div class="fields">
      <h2 class="title">Change Transparency</h2>
      <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off" name="changeTransparencyForm" id="changeTransparencyForm" class="active">
          <div>
            <label for="transparencyCalculation"> % Transparency </label>
            <select style="margin: 10px;" name="transparencyCalculation"[(ngModel)]="transparency">
              <option [value]=".1">10%</option>
              <option [value]=".2">20%</option>
              <option [value]=".3">30%</option>
              <option [value]=".4">40%</option>
              <option [value]=".5">50%</option>
              <option [value]=".6">60%</option>
              <option [value]=".7">70%</option>
              <option [value]=".8">80%</option>
              <option [value]=".9">90%</option>
              <option [value]="1">100%</option>
            </select>
          </div>
          <div class="fields__btn">
            <button type="submit" (click)="ok()"class="blue">Apply</button>
            <button (click)="bsModalRef.hide()" class="gray">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
